import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";

import { PayloadAction } from "@reduxjs/toolkit";
import { ISubscription } from "../../../Pages/Exam/IExam";
import {
  failureAddSubscription,
  successAddSubscription,
} from "./AddSubscriptionSlice";
import {
  failurelistSubscription,
  successlistSubscription,
} from "./ListSubscriptionSlice";
import {
  failuredeleteSubscription,
  successdeleteSubscription,
} from "./DeleteSubscriptionSlice";

// list exam id

const ListSubscriptionApi = (action: PayloadAction<ISubscription>) => {
  return api.get("/api/packagestripe/subscription", {
    params: action.payload,
  });
};

export function* ListSubscriptionCall(action: PayloadAction<ISubscription>) {
  try {
    const response: AxiosResponse = yield call(ListSubscriptionApi, action);
    yield put(successlistSubscription(response.data));
  } catch (error) {
    yield put(failurelistSubscription(error));
  }
}

const AddSubscriptionApi = () => {
  return api.post("/api/packagestripe/customer");
};

export function* AddSubscriptionCall() {
  try {
    const response: AxiosResponse = yield call(AddSubscriptionApi);
    yield put(successAddSubscription(response.data));
  } catch (error) {
    yield put(failureAddSubscription(error));
  }
}

// delete
const DeleteSubscriptionApi = (action: PayloadAction<number>) => {
  return api.delete("/api/package/subscription/cancel", {
    params: { subscription_id: action.payload },
  });
};

export function* DeleteSubscriptionCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteSubscriptionApi, action);
    yield put(successdeleteSubscription(response.data));
  } catch (error) {
    yield put(failuredeleteSubscription(error));
  }
}
